import StartStep from './StartStep';
import React, { useEffect, useState } from 'react';
import RoofSidesStep from './RoofSidesStep';
import { SelectedAddress } from '../App';
import { BuildingInfo } from '../services/MapIframe';
import ProductsStep from './ProductsStep';
import { Product } from './ProductsSelection';
import FinishStep from './FinishStep';

export enum AppView {
    INTRO = 1,
    ROOF_OVER_VIEW = 2,
    PRODUCTS_SELECTION = 3,
    FINISH = 4
}

function RootStep({ appView, setAppView, selectedProduct }: { appView: AppView, setAppView: React.Dispatch<AppView>, selectedProduct: Product|null}) {

    const [address, setAddress] = useState<SelectedAddress | null>(null);
    const [buildingInfo, setBuildingInfo] = useState<BuildingInfo | null>(null);

    useEffect(() => {
        window.addEventListener('message', function(e) {
            if (isBuildingInfo(e.data)) {
                setBuildingInfo(e.data as BuildingInfo);
            }
        });
    });

    switch (appView) {

        case AppView.INTRO:

            return <StartStep setAppView={setAppView}
                              address={address}
                              setAddress={setAddress}></StartStep>;

        case AppView.ROOF_OVER_VIEW:

            return <RoofSidesStep
                appView={appView}
                address={address}
                buildingInfo={buildingInfo}
                setAppView={setAppView}></RoofSidesStep>;

        case AppView.PRODUCTS_SELECTION:

            return <ProductsStep
                appView={appView}
                address={address}
                selectedProduct={selectedProduct}
                buildingInfo={buildingInfo}
                setAppView={setAppView}></ProductsStep>;

        case AppView.FINISH:

            return <FinishStep
                appView={appView}
                address={address}
                selectedProduct={selectedProduct}
                buildingInfo={buildingInfo}
                setAppView={setAppView}></FinishStep>;

        default:
            return <></>;

    }

}

const isBuildingInfo = (data: any) => {
    return data && data.roofSegments;
};

export default RootStep